// 命名规则
// 项目名称_组件名称_具体名称
module.exports = {
  language: {
    toastInfo: {
      pageLoad: "Page is loading... ",
    },
  },
};
